// Identificador de placa que entiende el servidor (/api/compile) para la placa de un proyecto. Las que tienen versiones
// u opciones (Pro Mini de 5 V o 3.3 V, reloj del ATtiny85) lo dan en `mcu.board`, según sus propiedades.
import { getDef, resolveProps } from './registry.js';

const BOARD_CODE = { 'arduino-uno': 'uno', 'arduino-nano': 'nano', 'arduino-mega': 'mega' };

export function boardIdOf(part) {
  const mcu = getDef(part.type).mcu;
  if (mcu && mcu.board) return mcu.board(resolveProps(part.type, part.props));
  return BOARD_CODE[part.type] || null;
}
